import React from 'react';
import styled from 'styled-components';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PieChartSection = ({ header, pieChartData, theme }) => {
    if (!pieChartData) return <div>Loading chart...</div>;
    const COLORS = ['#3e090a', '#d32f2f', '#ffc324', '#3c99f4'];

    const data = [
        { name: 'Critical', value: pieChartData.Critical },
        { name: 'High', value: pieChartData.High },
        { name: 'Medium', value: pieChartData.Medium },
        { name: 'Low', value: pieChartData.Low },
        { name: 'Info', value: pieChartData.Info }
    ];

    return (
        <PieChartContainer theme={theme}>
            <ResponsiveContainer width="100%" height={300}>
                <PieChartHeader>{header}</PieChartHeader>
                <PieChart>
                    <Pie
                        data={data}
                        dataKey="value"
                        nameKey="name"
                        outerRadius={80}
                        label
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </PieChartContainer>
    );
};

const PieChartContainer = styled.div`
    grid-column: span 1;
    background-color: ${({ theme }) => (theme === 'dark' ? '#231a2c' : '#fff')};
    color: ${({ theme }) => (theme === 'dark' ? '#fff' : '#34495e')};
    font-weight: 700;
    border-radius: 8px;
    box-shadow: ${({ theme }) => theme === 'dark' ? '0 4px 10px rgba(255, 255, 255, 0.1)' : '0 4px 10px rgba(0, 0, 0, 0.1)'};
    border-radius: 15px;
    padding: 20px;
    min-width: 480px;
    max-width: 600px;
    margin: 20px;
    box-shadow: ${({ theme }) => theme === 'dark' ? '0 8px 20px rgba(0, 0, 0, 0.4)' : '0 8px 20px rgba(0, 0, 0, 0.1)'};
    transition: transform 0.3s ease;
    &:hover {
        transform: scale(1.02);
    }
    @media screen and (max-width: 768px) {
        min-width: 200px;
    };
`;

const PieChartHeader = styled.div`
    text-align: center;
`;

export default PieChartSection;
